import classNames from "classnames";
import { FESTIVAL_TYPE } from "@features/landing/types";
import { festivalColors } from "@features/landing/helpers/constants/festival-colors";
import HeroRightSide from "./RightSide";
import HeroLeftSide from "./LeftSide";
import { festivalStyles } from "@features/landing/helpers/constants/festival-styles";
import { useMediaQuery } from "@shared/hooks/useMediaQuery";
import { festivalImage } from "@features/landing/helpers/constants/festival-image";
import Image from "next/image";
import { getDiscountNumber } from "@features/landing/helpers/functions";
interface Props {
  theme: FESTIVAL_TYPE;
  title: string;
  discountText?: string;
  specialText: string;
  price?: string;
  amount?: string;
  expireDate: number | Date;
}

const FestivalHero: React.FC<Props> = ({
  theme,
  title,
  specialText,
  discountText,
  expireDate,
}) => {
  const isMobile = useMediaQuery("(max-width:576px)");

  const themeImages = festivalImage[theme];
  const themeColors = festivalColors[theme];
  const themeStyles = festivalStyles[theme];

  const discountNumber = getDiscountNumber(discountText);

  const hasSpecificImage = Boolean(
    discountNumber && themeImages.background?.[discountNumber]
  );

  const heroImage = hasSpecificImage
    ? discountNumber
      ? themeImages.background[discountNumber]
      : ""
    : themeImages.leftImage;

  return (
    <section
      className={classNames(
        "relative pb-11 pt-5 sm:pt-0 sm:pb-[80px] sm:h-[455px] flex items-center overflow-hidden",
        isMobile ? themeColors.introColorMobile : themeColors.introColor
      )}
    >
      <div className="hidden sm:block absolute top-7 bottom-[29px] left-4 right-4 z-1 2xl:left-[135px] xl:right-[73px]">
        <Image
          src={themeImages.patternBackground}
          alt="festival background"
          fill
          className="object-cover"
        />
      </div>

      <div
        className={classNames(
          "relative z-3 px-2 mx-auto flex sm:flex-row flex-col-reverse sm:pb-0 h-full",
          themeStyles.wrapper
        )}
      >
        <HeroRightSide
          theme={theme}
          title={title}
          discountText={discountText}
          specialText={specialText}
          expireDate={expireDate}
        />

        <HeroLeftSide theme={theme} />

        {heroImage && (
          <div
            className={classNames(
              "hidden lg:block relative flex-1 z-3 h-full mt-[4%]",
              !hasSpecificImage && "max-w-[330px] w-full mx-auto"
            )}
          >
            <Image
              src={heroImage}
              alt="festival hero"
              fill
              className="object-contain"
            />
          </div>
        )}
      </div>
    </section>
  );
};

export default FestivalHero;
